module.exports = __webpack_public_path__ + "img/gift4-01-c06-y1.d6964403.png";